import ModuleConfig from './Config';
import moment from 'moment';
const actions = ModuleConfig.Actions;

const initialState = {
    data: [],
    flatData: [],
    count: 0,
    page: 1,
    pageCount: 1,
    pageSize: 20,
    search: "",
    searchColumn: "",
    sortDirection: "",
    current: {},
    errors: {},
    restructure: false,
    updated: moment().format('YYYYMMDDHHmmss')
}

export default function categories(state = initialState, action) {
    switch(action.type) {
        case actions.getAll.success.id:
            return Object.assign({}, state, {
                data: action.options.data,
                flatData: action.options.flatData,
                count: action.options.count,
                pageSize: action.options.pageSize,
                page: action.options.page,
                pageCount: action.options.pageCount,
                search: action.options.search,
                sortColumn: action.options.sortColumn,
                sortDirection: action.options.sortDirection,
                updated: moment().format('YYYYMMDDHHmmss')
            })
        case actions.getOne.success.id:
        case actions.edit.success.id:
            return Object.assign({}, state, {
                current: action.options,
                errors: {}
            })
        case actions.edit.failure.id:
        case actions.create.failure.id:
            return Object.assign({}, state, {
                errors: action.options
            })
        case actions.delete.success.id:
            return Object.assign({}, state, {
                current: {},
                errors: {}
            })
        case actions.openRestructure.id:
            return Object.assign({}, state, {
                restructure: true
            })
        case actions.closeRestructure.id:
            return Object.assign({}, state, {
                restructure: false
            })
        default:
            return state;
    }
}